/**
 * 사업자번호 검색시 검색키워드를 변환하기 위한 정규식
 */
export const BUSINESS_NUMBER_FORMAT = /\d{3}(-\d+)?(-\d*)?$/
